import { render } from "./ReferFriendView.vue?vue&type=template&id=0b376188&scoped=true"
import script from "./ReferFriendView.vue?vue&type=script&lang=js"
export * from "./ReferFriendView.vue?vue&type=script&lang=js"

import "./ReferFriendView.vue?vue&type=style&index=0&id=0b376188&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b376188"]])

export default __exports__